import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNdd } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD: Record<
  Exclude<PageIdWoofzNdd, PageIdWoofzNdd.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NDD]: {
    id: PageId.SUBSCRIPTIONS_NDD,
    hasHeader: false,
  },
  [PageId.CANCEL_OFFER_NDD]: {
    id: PageId.CANCEL_OFFER_NDD,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_NDD]: {
    id: PageId.CHAT_UPSELL_NDD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NDD]: {
    id: PageId.UPSELL_NDD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NDD]: {
    id: PageId.DOWNLOAD_NDD,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
